import React from 'react';

export const ArrowDown = ({
  className,
  color,
  height,
  width,
}: {
  className?: string;
  color?: string;
  height?: string;
  width?: string;
}) => (
  <svg
    width={width || '8'}
    height={height || '9'}
    viewBox="0 0 8 9"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_1659_31049)">
      <path
        d="M4.33301 7.08301L6.66634 4.74967L4.33301 2.41634M6.66634 4.74967L1.33301 4.74967L6.66634 4.74967Z"
        stroke={color || '#60321F'}
        strokeWidth="1.3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_1659_31049">
        <rect
          width="8"
          height="8"
          fill="white"
          transform="translate(0 8.75) rotate(-90)"
        />
      </clipPath>
    </defs>
  </svg>
);
